import {
    SET_CHAR,
    SET_WORD,
    TIMER_DECREMENT,
    TIMERID_SET,
    TIMER_SET,
    APPEND_TYPED_HISTORY,
    PREV_WORD,
    SET_WORDLIST,
    // SET_THEME,
    SET_TIME,
    SET_REF,
    SET_CARET_REF,
    SET_TYPE,
    SET_WPM,
    SET_CW,
    SET_IW,
    TIMER_STATE_SET,
    SET_INITIAL,
    SET_INITIAL_TIME,
} from "../actions/assessment.actions";

import persistReducer from "redux-persist/es/persistReducer";

import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";

import storage from 'redux-persist/lib/storage';
import JSOG from 'jsog'
import { createTransform } from "redux-persist";


export const initialState = {
    preferences: {
        theme: "",
        timeLimit: 0,
        type: "",
    },
    word: {
        currWord: "",
        typedWord: "",
        wpm: 0,
        correctWords: 0,
        incorrectWords: 0,
        typedHistory: [],
        wordList: [],
        activeWordRef: null,
        caretRef: null,
    },
    time: {
        timer: 1,
        timerId: null,
        state: ""
    },
};

export const JSOGTransform = createTransform(
    (inboundState, key) => JSOG.encode(inboundState),
    (outboundState, key) => JSOG.decode(outboundState),
)

const persistConfigTimer = {
  storage, 
  key: "time", 
  stateReconciler: autoMergeLevel2
};

const timerReducer = persistReducer( persistConfigTimer,(
    state = initialState.time,
    { type, payload }
) => {
    switch (type) {
        case TIMER_DECREMENT:
            return { ...state, timer: state.timer - 1 };
        case TIMER_SET:
            return { ...state, timer: payload };
        case TIMERID_SET:
            return { ...state, timerId: payload };
        case TIMER_STATE_SET:
            return { ...state, state: payload };
        case SET_INITIAL_TIME:
            return { ...initialState.time };
        default:
            return state;
    }
}
)

const persistConfigWord = {
  storage, 
  key: "word", 
  stateReconciler: autoMergeLevel2,
  transforms: [JSOGTransform]
};

const wordReducer = persistReducer(persistConfigWord, (
    state = initialState.word,
    { type, payload }
) => {
    switch (type) {
        case SET_CHAR:
            return { ...state, typedWord: payload };
        case SET_WORD:
            return { ...state, typedHistory: [...state.typedHistory, payload] };
        case SET_WPM:
            return { ...state, wpm: payload };
        case SET_CW:
            return { ...state, correctWords: payload };
        case SET_IW:
            return { ...state, incorrectWords: payload };
        case APPEND_TYPED_HISTORY:
            const nextIdx = state.typedHistory.length + 1;
            return {
                ...state,
                typedWord: "",
                currWord: state.wordList[nextIdx],
                typedHistory: [...state.typedHistory, state.typedWord],
            };
        case PREV_WORD:
            const prevIdx = state.typedHistory.length - 1;
            return {
                ...state,
                currWord: state.wordList[prevIdx],
                typedWord: !payload ? state.typedHistory[prevIdx] : "",
                typedHistory: state.typedHistory.splice(0, prevIdx),
            };
        case SET_REF:
            return {
                ...state,
                activeWordRef: payload,
            };
        case SET_CARET_REF:
            return {
                ...state,
                caretRef: payload,
            };
        case SET_WORDLIST:
            const areNotWords = payload.some((word) =>
                word.includes(" ")
            );
            var shuffledWordList = payload.sort(
                () => Math.random() - 0.5
            );
            if (areNotWords)
                shuffledWordList = payload.flatMap((token) =>
                    token.split(" ")
                );
            return {
                ...state,
                typedWord: "",
                typedHistory: [],
                currWord: shuffledWordList[0],
                wordList: shuffledWordList,
            };
                // Split the payload strings into words and store them in an object
                // const words = {
                //     array1: payload[0].split(" "),
                //     array2: payload[1] ? payload[1].split(" ") : [],
                //     array3: payload[2] ? payload[2].split(" ") : []
                // };

                // // Get the keys of the words object
                // const keys = Object.keys(words);

                // // Shuffle the keys array to randomize the selection of arrays
                // const shuffledKeys = keys.sort(() => Math.random() - 0.5);

                // // Pick the first array from the shuffled keys
                // const selectedArray = words[shuffledKeys[0]];

                // // Return the new state
                // return {
                //     typedWord: "",
                //     typedHistory: [],
                //     currWord: selectedArray[0],
                //     wordList: selectedArray,
                // };
        case SET_INITIAL:
            return {
                ...initialState.word
            }
        default:
            return state;
    }
}
)

const persistConfigPreferences = {
  storage, 
  key: "preferences", 
  stateReconciler: autoMergeLevel2,
//   transforms: [JSOGTransform]
};


const preferenceReducer = persistReducer(persistConfigPreferences, (
    state = initialState.preferences,
    { type, payload }
) => {
    switch (type) {
        case SET_TIME:
            return {
                ...state,
                timeLimit: payload,
            };
        case SET_TYPE:
            return {
                ...state,
                type: payload,
            };
        default:
            return state;
    }
}
)

export { preferenceReducer, wordReducer, timerReducer}
